/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import QtmColor from './Color';
import common from './common';

const red: QtmColor = {
  50: '#FFEAEE',
  100: '#FFCBD2' /* pink */,
  200: '#F99698' /* light */,
  300: '#F26C6F',
  400: '#FE444A',
  500: '#FF2A2B',
  600: '#F51B2C',
  700: '#E30526' /* primary */,
  800: '#D6001E',
  900: '#C8000F' /* dark */,
  contrast: {
    50: common.black,
    100: common.black,
    200: common.black,
    300: common.black,
    400: common.black,
    500: common.black,
    600: common.black,
    700: common.white,
    800: common.white,
    900: common.white,
  },
};

export default red;
